/*
* 首页公告栏
*/
<template>
  <v-card flat
          mx-auto
          color="">
    <!-- <v-card-title class="pt-0 pb-0 pl-0"> -->
    <v-card-title :style="showDashboardRank?'padding-left:0;padding-top:16px;':'padding-left:0;padding-top:6px;'">
      <span class="title dashboard-title">Bulletin Board</span>
    </v-card-title>
    <v-card-text :class="showDashboardRank?'broad-text py-0 word-break pl-0 pr-0 pb-3':'py-0 word-break pl-0 pr-0 pb-3'" :style="showDashboardRank?'max-height:8rem;':''" v-if="!isLoading">
      <h3 class="text-xs-left pt-4 blue-title broad-title" >{{board.Title}}</h3>
      <div :class=" showDashboardRank?'pt-4':'broad-text pt-4' " :style="personShow?'max-height:20.4rem;':''" v-html="board.Content" >
     
      </div>
    </v-card-text>
    <v-layout row align-center wrap text-xs-center pt-4 v-else>
      <v-flex md12 lg12 text-xs-center mt-4 pt-4 class="pr-3 pb-4 report-trial-loading">
            <v-progress-circular indeterminate :size="50" color="grey"></v-progress-circular>
        </v-flex>
    </v-layout>

  </v-card>
</template>

<script>
import { getBulletinBoard } from '@/api/dashboard'
import { consoleInfo } from 'vuetify/src/util/console'
export default {
  props: ['showDashboardRank','personShow'],
  data: () => ({
    board: {},
    isLoading: false,
    // showTwinkle: false
  }),
  mounted () {
    this.getBulletinBoard()
  },
  methods: {
    getBulletinBoard () {
      this.isLoading = true
      getBulletinBoard().then(board => {
        this.board = board
        this.isLoading = false
        // let curTime = new Date().getTime()
        // let creatTime = this.board.CreateTs
        // let oneDay = 86400000
        // if (curTime - creatTime >= oneDay) { // 判断一天以内的消息 图标闪烁
        //   this.showTwinkle = false
        // } else {
        //   this.showTwinkle = true
        // }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .fix-broad-ico {
    width: 26px;
    height: 26px;
  }
  .broad-name{
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .broad-title{
    font-size: 14px;
  }
  .broad-text{
    line-height: 26px;
    // height: 28em;
    overflow: hidden;
    word-wrap: break-word;
    word-break: break-word;
    color: #5B6195;
    max-height:21em;
  }
  .broad-text:hover{
    overflow: auto;
  }
  [data-theme="theme1"] .broad-text{
    color: #ececec;
  }
  .word-break{
    word-break: break-all;
    overflow-wrap: break-word;
  }
</style>
<style>
  [data-theme="theme1"] .broad-text p {
    color: #ececec!important;
  }
  .broad-text p {
    margin-bottom: 0;
    word-wrap: break-word;
    word-break: break-word;
  }
  .twinkle-img{
    background: url(../../../assets/img/dashboard/sound.gif) no-repeat;
    width: 18px;
    height: 18px;
    background-size: contain;
  }
  .twinkle-text{
    animation: fade 1200ms infinite;
    -webkit-animation: fade 1200ms infinite;
  }
  @keyframes fade {
    from {
        opacity: 1.0;
    }
    to {
        opacity: 0.7;
    }
}

@-webkit-keyframes fade {
    from {
        opacity: 1.0;
    }
    to {
        opacity: 0.7;
    }
}
</style>
